import { render, staticRenderFns } from "./returnedMoney.vue?vue&type=template&id=23d747bd&scoped=true&"
import script from "./returnedMoney.vue?vue&type=script&lang=js&"
export * from "./returnedMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d747bd",
  null
  
)

export default component.exports